import { css } from '@emotion/react';
import { useEffect } from 'react';
import {
  PermanentConfirmStrategy, useConfirmationModal,
} from '~/_shared/components/modal/confirmation/useConfirmationModal';
import { isInsideSalesforceIframe } from '~/_shared/utils/3rdPartyIntegrations/crm/salesforce/salesforce.helpers';
import { useTranslation } from '~/_shared/utils/hooks';
import { checkIsSalesforceMap } from '~/store/mapInfo/mapInfo.helpers';
import { useMapInfoDataSelector } from '~/store/mapInfo/mapInfo.selectors';
import { useIsMapEditDisabled } from '~/store/selectors/useMapInfoSelectors';
import {
  s, Trans,
} from '~/translations/Trans';
import sfUpdateMapButtonPositionImage from '../../../../../../../assets/images/3rdPartyLogos/sf-update-map.png';

const boldStyle = css({
  fontWeight: 'bold',
});

const imageStyle = css({
  marginTop: 10,
  maxWidth: 250,
});

export const useSalesforceDataWarning = () => {
  const [t] = useTranslation();
  const mapInfo = useMapInfoDataSelector();
  const isEditModeDisabled = useIsMapEditDisabled();
  const { openConfirmationModal, closeConfirmationModal } = useConfirmationModal();

  const isSalesforceMap = checkIsSalesforceMap(mapInfo);

  useEffect(() => {
    if (isSalesforceMap && !isInsideSalesforceIframe() && !isEditModeDisabled) {
      openConfirmationModal({
        confirmCaption: t('Got it'),
        title: t('salesforce.outsideOfSalesforce.howToRefreshDataNotice.caption'),
        text: (
          <div>
            <div>
              <Trans i18nKey="salesforce.outsideOfSalesforce.howToRefreshDataNotice.description">
                {s('prefix')}
                <span
                  css={boldStyle}
                />
                {s('suffix')}
              </Trans>
            </div>
            <div>
              <img
                css={imageStyle}
                src={sfUpdateMapButtonPositionImage}
                alt="Position of the Update Map button inside Salesforce"
              />
            </div>
          </div>
        ),
        onConfirm: closeConfirmationModal,
        permanentConfirmSettings: {
          id: 'salesforce-data-update-warning',
          strategy: PermanentConfirmStrategy.Local,
        },
      });
    }
  }, [mapInfo?.id, isSalesforceMap, isEditModeDisabled, closeConfirmationModal, openConfirmationModal, t]);
};
